// extracted by mini-css-extract-plugin
export default {"icon":"use-position-table-actions_icon__7fInJ"};